// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deploymentDetailsForm {
    display: flex;
    flex-direction: column;
}

input {
    height: 2rem;
    width: 20rem;
    align-self: center;
    border-radius: 5px;
}

.deploymentDetailsFormSubmitButton {
    width: 10rem;
    background-color: #3f51b5;
    color: white;
    padding: 15px 30px;
    border-radius: 5px;
    outline: 0;
    border: 0; 
    margin: 10px 0px;
    cursor: pointer;
    box-shadow: 0px 2px 2px lightgray;
    transition: ease background-color 250ms;
    font-weight: bold;
    align-self: center;
}

.deploymentDetailsFormSubmitButton:hover:not(:disabled) {
    background-color: #283593;
}

.deploymentDetailsFormSubmitButton:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.userEmailDisplay {
  position: absolute;
  top: 10px;
  right: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 5px 15px;
  border-radius: 12px;
  font-size: 14px;
  
  /* Add these lines for alignment */
  display: flex;
  align-items: center;
  gap: 15px; /* Adds space between the email and the button */
}

/* Style for the email text */
.user-email-display strong {
  color: #ffffff;
}

/* Add this new rule for the logout button */
.logout-button {
  background-color: transparent;
  border: 1px solid #ffc1c1;
  color: #ffc1c1;
  padding: 4px 8px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-button:hover {
  background-color: #d93025;
  color: white;
  border-color: #d93025;
}`, "",{"version":3,"sources":["webpack://./src/bootstrapMessaging.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;;EAEf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,gDAAgD;AAC7D;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":[".deploymentDetailsForm {\n    display: flex;\n    flex-direction: column;\n}\n\ninput {\n    height: 2rem;\n    width: 20rem;\n    align-self: center;\n    border-radius: 5px;\n}\n\n.deploymentDetailsFormSubmitButton {\n    width: 10rem;\n    background-color: #3f51b5;\n    color: white;\n    padding: 15px 30px;\n    border-radius: 5px;\n    outline: 0;\n    border: 0; \n    margin: 10px 0px;\n    cursor: pointer;\n    box-shadow: 0px 2px 2px lightgray;\n    transition: ease background-color 250ms;\n    font-weight: bold;\n    align-self: center;\n}\n\n.deploymentDetailsFormSubmitButton:hover:not(:disabled) {\n    background-color: #283593;\n}\n\n.deploymentDetailsFormSubmitButton:disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n.userEmailDisplay {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  background-color: rgba(0, 0, 0, 0.3);\n  padding: 5px 15px;\n  border-radius: 12px;\n  font-size: 14px;\n  \n  /* Add these lines for alignment */\n  display: flex;\n  align-items: center;\n  gap: 15px; /* Adds space between the email and the button */\n}\n\n/* Style for the email text */\n.user-email-display strong {\n  color: #ffffff;\n}\n\n/* Add this new rule for the logout button */\n.logout-button {\n  background-color: transparent;\n  border: 1px solid #ffc1c1;\n  color: #ffc1c1;\n  padding: 4px 8px;\n  border-radius: 5px;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logout-button:hover {\n  background-color: #d93025;\n  color: white;\n  border-color: #d93025;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
